import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingPage = () => (
    <div className="loader">
        <Spinner />
    </div>
);

export default LoadingPage;